import {useCallback} from '@wordpress/element';
import {useDispatch} from '@wordpress/data';
import {CART_STORE_KEY} from '@woocommerce/block-data';
import {STORE_KEY} from '@wc-braintree/block-data';
import {extractFullName} from '../utils';
import {setCustomerContextId} from "../../data/checkout/actions";

export const useManageFastlanePaymentToken = (
    {
        fastlane
    }) => {

    const {
        setPaymentToken,
        setCustomerContextId
    } = useDispatch(STORE_KEY);

    const {
        setBillingAddress
    } = useDispatch(CART_STORE_KEY);

    const {
        createErrorNotice
    } = useDispatch('core/notices');

    const onCancel = useCallback(() => {
        setPaymentToken(null);
        setCustomerContextId(null);
    }, []);

    const onChangePaymentMethod = useCallback(async () => {
        try {
            const {
                selectedCard,
                selectionChanged
            } = await fastlane.profile.showCardSelector();

            if (selectedCard && selectionChanged) {
                setPaymentToken(selectedCard);

                if (selectedCard?.paymentSource?.card?.billingAddress) {
                    const name = selectedCard.paymentSource.card.name;
                    const [firstName, lastName] = extractFullName(name);
                    const address = {
                        firstName,
                        lastName,
                        ...selectedCard.paymentSource.card.billingAddress
                    };

                    setBillingAddress({
                        first_name: address.firstName || '',
                        last_name: address.lastName || '',
                        address_1: address?.streetAddress || '',
                        address_2: address?.extendedAddress || '',
                        city: address?.locality || '',
                        state: address?.region || '',
                        postcode: address?.postalCode || '',
                        country: address?.countryCodeAlpha2 || '',
                    });
                }
            }
        } catch (error) {
            createErrorNotice(error.message, {
                id: 'wc-ppcp-tokenize-error',
                context: 'wc/checkout/payments'
            });
        }
    }, [fastlane]);

    return {
        onCancel,
        onChangePaymentMethod
    }

}